export default __webpack_public_path__ + "static/media/logo.dc119a57.png";